"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMonthGrid = buildMonthGrid;
exports.getMonthRange = getMonthRange;
var CALENDAR_GRID_DAYS = 42;
function buildMonthGrid(monthDate) {
    var year = monthDate.getFullYear();
    var month = monthDate.getMonth();
    var firstOfMonth = new Date(year, month, 1);
    var gridStart = new Date(year, month, 1 - firstOfMonth.getDay());
    return Array.from({ length: CALENDAR_GRID_DAYS }, function (_, index) {
        var day = new Date(gridStart);
        day.setDate(gridStart.getDate() + index);
        return day;
    });
}
function getMonthRange(monthDate) {
    var dateFrom = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
    var dateTo = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0);
    dateTo.setHours(23, 59, 59, 999);
    return { dateFrom: dateFrom, dateTo: dateTo };
}
